import { __assign, __rest } from "tslib";
import React from "react";
import Svg from "./Svg";

var SvgHome = function SvgHome(_a) {
  var _b = _a.size,
      size = _b === void 0 ? 24 : _b,
      props = __rest(_a, ["size"]);

  return React.createElement(Svg, __assign({
    fill: "currentColor",
    viewBox: "0 0 25 24",
    size: size
  }, props), React.createElement("g", {
    fill: "currentColor",
    clipPath: "url(#home_svg__clip0)"
  }, React.createElement("path", {
    d: "M22.605 16v5.547c0 1.078-.891 2.015-2.016 2.015h-3.984a.99.99 0 01-.985-.984v-5c0-1.64-1.36-3-3-3s-3 1.36-3 3v5a.99.99 0 01-.984.985H4.65c-1.078 0-2.015-.891-2.015-2.016v-5.594c0-.281.093-.515.281-.703l8.953-8.953a1.02 1.02 0 011.406 0l8.954 9a.778.778 0 01.375.703z"
  }), React.createElement("path", {
    d: "M23.62 13.406c-.234 0-.515-.094-.703-.281L12.62 2.875 2.37 13.125a1.02 1.02 0 01-1.406 0 1.02 1.02 0 010-1.406l10.953-11a.954.954 0 01.703-.281c.281 0 .516.093.703.28l11 11a1.02 1.02 0 010 1.407 1.033 1.033 0 01-.703.281z"
  })), React.createElement("defs", null, React.createElement("clipPath", {
    id: "home_svg__clip0"
  }, React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h24v24H0z",
    transform: "translate(.644)"
  }))));
};

export default SvgHome;